module.exports = __webpack_public_path__ + "static/media/icon-pause-large.17e3bc14.svg";